import Link from 'next/link';

interface Props {
  href: string;
  className?: string;
  children: React.ReactNode;
}

export default function A({ href, className, children }: Props) {
  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}
